import {setupListeners} from "@reduxjs/toolkit/query/react";
import {configureStore, type EnhancedStore} from "@reduxjs/toolkit/react";
import {appApi} from "@src/integrations/redux/app-api";
import {authMiddleware} from "@src/features/auth/redux/auth-middleware";
import {authReducer} from "@src/features/auth/redux/auth-slice";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";

// todo tried removing EnhancedStore (since it needs generic params and
//  I don't know what to put there) and suddenly selectors stopped working... look into it
export const appStore: EnhancedStore = configureStore({
	devTools: process.env.NODE_ENV === "development",
	reducer: {
		[appApi.reducerPath]: appApi.reducer,
		auth: authReducer,
	},
	middleware(getDefaultMiddleware) {
		return getDefaultMiddleware()
			.concat(
				appApi.middleware
			)
			.prepend(  // todo why not concat
				authMiddleware.middleware
			);
	}
});

const listenersHandler = setupListeners(appStore.dispatch);

export type AppState = ReturnType<typeof appStore.getState>;

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export type AppDispatch = typeof appStore.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
